var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contentThreeBox"},_vm._l((_vm.warningList),function(item,index){return _c('div',{key:index,staticClass:"grid"},[_c('dv-border-box-12',[_c('Table1',{attrs:{"title":item.title,"config":item.config}})],1)],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }